import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import api, { downloadFile } from "../lib/api";
import StatusBadge from "../components/StatusBadge";

export default function DettaglioRichiestaPage() {
  const { id } = useParams();
  const [richiesta, setRichiesta] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/agibilita/${id}`).then((res) => setRichiesta(res.data)).catch(() => setError("Richiesta non trovata o non accessibile."));
  }, [id]);

  if (error) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-16 text-center" data-testid="dettaglio-error">
        <p className="text-sm text-red-700">{error}</p>
        <Link to="/le-mie-richieste" className="btn-outline-bordeaux mt-6">TORNA ALLE MIE RICHIESTE</Link>
      </div>
    );
  }
  if (!richiesta) return <div className="mx-auto max-w-3xl px-4 py-16 text-sm text-muted-foreground">Caricamento...</div>;

  const campi = [
    ["Nome e Cognome", richiesta.nome_cognome],
    ["Nome del locale", richiesta.nome_locale],
    ["Indirizzo del locale", richiesta.indirizzo_locale],
    ["Città", richiesta.citta],
    ["Provincia", richiesta.provincia],
    ["C.A.P.", richiesta.cap],
    ["Attività", richiesta.attivita],
    ["Data dell'esibizione", new Date(richiesta.data_esibizione).toLocaleDateString("it-IT")],
    ["Importo pattuito", `€ ${richiesta.importo.toFixed(2)}`],
    ["Email per il certificato", richiesta.email_certificato],
    ["Data e ora della richiesta", new Date(richiesta.created_at).toLocaleString("it-IT")],
  ];

  const scarica = async (tipo) => {
    try {
      await downloadFile(`/agibilita/${id}/${tipo}`, `${tipo}-${richiesta.numero_pratica}.pdf`);
    } catch {
      toast.error("Download non riuscito. Riprova.");
    }
  };

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6" data-testid="dettaglio-richiesta-page">
      <Link to="/le-mie-richieste" data-testid="dettaglio-back-link" className="inline-flex items-center gap-1 text-sm font-semibold text-bordeaux hover:underline">
        <ArrowLeft className="h-4 w-4" /> Le mie richieste
      </Link>

      <div className="card-elegant mt-6">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">Pratica</p>
            <h1 className="font-heading text-2xl font-bold text-bordeaux-dark sm:text-3xl" data-testid="dettaglio-numero-pratica">
              {richiesta.numero_pratica}
            </h1>
          </div>
          <StatusBadge stato={richiesta.stato} />
        </div>
        <div className="mt-5 flex flex-wrap gap-3">
          <button onClick={() => scarica("ricevuta")} data-testid="dettaglio-ricevuta-btn" className="btn-outline-bordeaux !px-4 !py-2 text-xs">
            SCARICA RICEVUTA PDF
          </button>
          {richiesta.certificato_disponibile && (
            <button onClick={() => scarica("certificato")} data-testid="dettaglio-certificato-btn" className="btn-bordeaux !px-4 !py-2 text-xs">
              SCARICA CERTIFICATO DI AGIBILITÀ
            </button>
          )}
        </div>
        <dl className="mt-6 divide-y divide-border">
          {campi.map(([k, v]) => (
            <div key={k} className="flex flex-wrap justify-between gap-2 py-3 text-sm">
              <dt className="text-muted-foreground">{k}</dt>
              <dd className="font-medium text-foreground">{v}</dd>
            </div>
          ))}
        </dl>

        {richiesta.pagamento && (
          <div className="mt-6 rounded-lg border border-bordeaux/30 bg-bordeaux-ultralight p-5" data-testid="dettaglio-pagamento">
            <h2 className="font-heading text-lg font-semibold text-bordeaux-dark">Pagamento</h2>
            <dl className="mt-3 divide-y divide-border">
              <div className="flex flex-wrap justify-between gap-2 py-2 text-sm">
                <dt className="text-muted-foreground">Importo</dt>
                <dd className="font-medium" data-testid="pagamento-importo-dettaglio">€ {richiesta.pagamento.importo?.toFixed(2)}</dd>
              </div>
              <div className="flex flex-wrap justify-between gap-2 py-2 text-sm">
                <dt className="text-muted-foreground">Metodo di pagamento</dt>
                <dd className="font-medium">{richiesta.pagamento.metodo === "paypal" ? "PayPal" : "Bonifico bancario"}</dd>
              </div>
              <div className="flex flex-wrap items-center justify-between gap-2 py-2 text-sm">
                <dt className="text-muted-foreground">Stato del pagamento</dt>
                <dd><StatusBadge stato={richiesta.pagamento.stato} /></dd>
              </div>
              {richiesta.pagamento.data && (
                <div className="flex flex-wrap justify-between gap-2 py-2 text-sm">
                  <dt className="text-muted-foreground">Data del pagamento</dt>
                  <dd className="font-medium">{new Date(richiesta.pagamento.data).toLocaleString("it-IT")}</dd>
                </div>
              )}
            </dl>
          </div>
        )}
      </div>
    </div>
  );
}
